module.exports = __webpack_public_path__ + "static/media/logo_alt.aca69ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logo_alt.png
// module id = 835
// module chunks = 0